import React, { useContext, useEffect } from 'react';
import styles from './my.module.sass';
import cn from 'classnames';
import Grid from '@mui/material/Grid';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Logout } from '@mui/icons-material';
import { UserContext } from '../../contexts/UserContext';
import UserPhoto from '../../components/UserPhoto';
import AccountItem from './AccountItem';
import { Redirect} from "react-router-dom";
import { ConquerContext } from '../../contexts/ConquerContext';

const NAccount = ({ children }) => {

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );

    const userData = userContext && userContext.userData ? userContext.userData : {};

    function doLogout() {

        if( !userData.isLogged ) return;
        conquer.Auth.logout();
        userContext.refresh();

    }
    
    return (
        <div className={styles.container}>
            { conquer.isInitialized && !userData.isLogged && <Redirect to={'/'}/> }
            <Grid container spacing={2}>
                {/* 1st row - 1 */}
                <Grid item xs={12} md={8}>
                    <div className={styles.section_picture}>
                        <UserPhoto/>
                        <Grid container spacing={0} className={styles.namebox}>
                            <Grid item xs={10} style={{ paddingTop: '0px' }}>
                                <p className={styles.name}>{userData.firstName}</p>
                                <p className={styles.username}>{userData.username}</p>
                                <p className={styles.text_small}>
                                    Lorem ipsum dolor sit amet, consectetuer
                                    adipiscing elit, sed diam nonum
                                </p>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
                {/* 1st row - 2 */}
                <Grid item xs={12} md={4}>
                </Grid>
                {/* 2nd row - 1 */}
                <Grid item xs={12} md={8}>
                    <div className={cn(styles.gray_box, styles.accordion)}>
                        {/* item */}
                        <AccountItem title="Edit Account" icon={<PersonOutlineOutlinedIcon />} path={'/profile-edit'}/>
                        <AccountItem title="Logout" icon={<Logout />} onClick={ doLogout } />
                    </div>
                </Grid>
                {/* 2nd row - 2  */}
                {/* <Grid item xs={12} md={4}>
                    <div className={cn(styles.gray_box)}>
                        <Grid container spacing={2}>
                            <Grid item xs={9}>
                                <h3>Recent Activity</h3>
                                <p className={cn(styles.text_small)}>
                                    See your recent activity on GameBop
                                </p>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    variant='outlined'
                                    className={styles.iconbox}>
                                    <KeyboardArrowRightIcon />
                                </Button>
                            </Grid>
                        </Grid>

                        <div className={cn(styles.activities)}>
                            {[1, 2, 3].map((item, index) => (
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ marginTop: '10px' }}>
                                    <Grid
                                        item
                                        xs={2}
                                        style={{ textAlign: 'right' }}>
                                        <img
                                            src='/images/content/avatar-1.jpg'
                                            alt='Avatar'
                                        />
                                    </Grid>
                                    <Grid item xs={7}>
                                        <p>Your commented PUBG Crew's post</p>
                                        <p className={cn(styles.text_mute)}>
                                            Lorem ipsum dolor sit amet, cons...
                                        </p>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <span className={cn(styles.text_mute)}>
                                            4h ago
                                        </span>
                                    </Grid>
                                </Grid>
                            ))}
                        </div>
                    </div>
                </Grid> */}
            </Grid>
        </div>
    );
};

export default NAccount;
